import * as React from "react";
import { Box, Button, Typography, Grid2, TextField, Snackbar, Alert, useMediaQuery } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from "../StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from "../StepperComponents";
import { useSelector, useDispatch } from "react-redux";
import icon from '../../../Assets/Images/icon.svg'
import {
  generateAadharOtp,
  setAadharStatus,
  setActiveStep,
  setPanStatus,
  verifyAadharOtp,
} from "../../../Redux/usersSlice";
import PanStyles from "./pansStyle.module.css";
// import AadharStyles from "./Aadhar.module.css";
import panImg from "../../../Assets/Images/panImg.png";
// import icon from "../../../Assets/Images/icon.svg";
// import aadharImg from "../../../Assets/Images/aadhar1.svg";
import { verifyPan } from "../../../Redux/usersSlice";
import Logo from "../../../Assets/Images/logo.svg";
import collab from '../../../Assets/Images/collab1.svg';

export default function PanVerify() {
    const steps = useSteps();
  const navigate = useNavigate();
  const location = useLocation();
  const [pan, setPan] = React.useState("");
  const [toggle, setToggle] = React.useState(false);
  // const [aadhar, setAadhar] = React.useState("");
  // const [showAadharOtpScreen, setShowAadharOtpScreen] = React.useState(false);
  // const [otp, setOtp] = React.useState("");
  // const [transactionId, setTransactionId] = React.useState("");
  const [error,setError]=React.useState("")
  // const [verificationComplete, setVerificationComplete] = React.useState(false);

  React.useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "pan_page_viewed",
      page_path: window.location.pathname
    });
  }, []);

    // Snackbar state
    const [snackbar, setSnackbar] = React.useState({
      open: false,
      message: "",
      severity: "info", // 'error', 'warning', 'info', 'success'
    });

    const showMessage = (message, severity = "info") => {
      setSnackbar({ open: true, message, severity });
    };
  
    const handleCloseSnackbar = () => {
      setSnackbar(prev => ({ ...prev, open: false }));
    };

  const dispatch = useDispatch();
  const { activeStep, userData, loading, panVerified, aadharVerified,source } =
    useSelector((state) => state.user);
  const backendResponse = userData.steps;

      // const theme = useTheme();
    
  const isMobile = useMediaQuery('(max-width:1000px)');

  // const handleAadharChange = (e) => {
  //   const value = e.target.value;
  //   if (/^\d{0,12}$/.test(value)) {
  //     setAadhar(value);
  //   }
  // };

  // const handleKeyDown = (e, index) => {
  //   if (e.key === "Backspace" && !otp[index] && index > 0) {
  //     const prevInput = document.getElementById(`otp-${index - 1}`);
  //     if (prevInput) prevInput.focus();
  //   }
  // };

  // const handleChange = (e, index) => {
  //   const value = e.target.value;
  //   if (/^[0-9]*$/.test(value) && value.length <= 1) {
  //     const newOtp = otp.split("");
  //     newOtp[index] = value;

  //     setOtp(newOtp.join(""));

  //     if (value && index < 6) {
  //       const nextInput = document.getElementById(`otp-${index + 1}`);
  //       if (nextInput) nextInput.focus();
  //     }
  //   }
  // };

  // Check for persisted verification status on component mount
  React.useEffect(() => {
    if (panVerified === "true" || userData?.steps?.["Pan Verify"]?.status) {
      setToggle(true);
    }

    // Check if both PAN and Aadhar are verified
    if (
      (panVerified === "true" || userData?.steps?.["Pan Verify"]?.status) 
      // &&
      // (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status)
    ) {
      // Move to next step or show success
      const nextStep = activeStep + 1;
      if (nextStep < steps.length) {
        dispatch(setActiveStep(nextStep));
        navigate(steps[nextStep].path);
      }
    }
  }, [userData, panVerified, aadharVerified]);

  // Sync step with URL path
  React.useEffect(() => {
    const currentStep = steps.findIndex(
      (step) => step.path === location.pathname
    );
    if (currentStep !== -1) dispatch(setActiveStep(currentStep));
  }, [location.pathname, setActiveStep]);

  // const handleVerifyPanAndContinue = async () => {
  //   try {
  //     const result = await dispatch(
  //       verifyPan({
  //         mobile: userData.mobile,
  //         email: userData.email,
  //         pan_number: pan,
  //       })
  //     ).unwrap();

  //     console.log(result)

  //     if (result?.data?.success) {
  //       console.log("oneee")
  //       setError("")
  //       setToggle(true);
  //       dispatch(setPanStatus(result?.data))
  //     }else if(result?.data?.message==="Please provide a valid Pan."){
  //       setError("Please provide a valid Pan.")
  //     }else if(result?.data?.message === "PAN already exists"){
  //       setError("PAN already exists")
  //     }else{
  //       setError(result?.data?.message)
  //     }
  //   } catch (errorr) {
  //     console.error("PAN verification failed:", errorr);
  //     setError(errorr?.data?.data?.message)
  //   }
  // };

  const handleVerifyPanAndContinue = async () => {
  try {
    const result = await dispatch(
      verifyPan({
        mobile: userData.mobile,
        email: userData.email.toLowerCase(),
        pan_number: pan,
      })
    ).unwrap();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "pan_entered",
      page_path: window.location.pathname
    });
    if (result?.data?.success) {
      setError("");
      dispatch(setPanStatus(result?.data));
      
      // Navigate to next step immediately after PAN verification
      const nextStep = activeStep + 1;
      if (nextStep < steps.length) {
        dispatch(setActiveStep(nextStep));
        navigate(steps[nextStep].path);
      }
    } else if(result?.data?.message==="Please provide a valid Pan.") {
      setError("Please provide a valid Pan.");
    } else if(result?.data?.message === "PAN already exists") {
      setError("PAN already exists");
    } else {
      setError(result?.data?.message);
    }
  } catch (errorr) {
    console.error("PAN verification failed:", errorr);
    setError(errorr?.data?.data?.message);
  }
};

  // const handleAadharSubmit = async () => {
  //   try {
  //     const result = await dispatch(
  //       generateAadharOtp({
  //         mobile: userData.mobile,
  //         email: userData.email,
  //         aadhaar_number: aadhar,
  //       })
  //     ).unwrap();

  //     console.log(result);

  //     if (result?.data?.success) {
  //       setTransactionId(result.data.transaction_id);
  //       setShowAadharOtpScreen(true);
  //       setError("")
  //     }else if(result?.data?.message){
  //       setError(result?.data?.message)
  //     }
  //   } catch (errorr) {
  //     console.error("Aadhar OTP generation failed:", errorr);
  //     setError(errorr?.data?.data?.message)
  //   }
  // };

  // const handleAadharOtpSubmit = async () => {
  //   try {
  //     const result = await dispatch(
  //       verifyAadharOtp({
  //         mobile: userData.mobile,
  //         email: userData.email,
  //         aadhaar_number: aadhar,
  //         otp: otp,
  //         transaction_id: transactionId,
  //       })
  //     ).unwrap();

  //     console.log({
  //       mobile: userData.mobile,
  //       email: userData.email,
  //       aadhaar_number: aadhar,
  //       otp: otp,
  //       transaction_id: transactionId,
  //     });

  //     if (result?.data?.success) {
  //       // Mark verification as complete
  //       setError("")
  //       dispatch(setAadharStatus(result?.data))

  //       // Move to next step or show success
  //       const nextStep = activeStep + 1;
  //       if (nextStep < steps.length) {
  //         dispatch(setActiveStep(nextStep));
  //         navigate(steps[nextStep].path);
  //       }
  //     }else if(result?.data?.message){
  //       setError(result?.data?.message)
  //     }
  //   } catch (errorr) {
  //     console.error("Aadhar OTP verification failed:", errorr);
  //     setError(errorr?.data?.data?.message)
  //   }
  // };

  // const handleStepNavigate = () => {
  //  console.log("outside")

  //   if( !((panVerified === "true" || userData?.steps?.["Pan Verify"]?.status) &&
  //   (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status))){
  //     console.log("inside")

  //   window.alert(
  //     "please complete pan verification before proceeding to other steps"
  //   );
  // }
  // };

  const handleStepNavigate = (path) => {
    // Only check for PAN verification now
    if (path !== "/step-1" && !((panVerified === "true" || userData?.steps?.["Pan Verify"]?.status)))
      //  &&
      // (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status))) 
      {
      // window.alert("Please complete PAN verification before proceeding to other steps");
      showMessage("Please complete PAN and KYC verification before proceeding", "warning");
      return;
    }

    // const stepIndex = steps.findIndex((step) => step.path === path);
    // if (stepIndex !== -1) {
    //   dispatch(setActiveStep(stepIndex));
    //   navigate(path);
    // }
  };


  // const handleBack=()=>{
  //   setShowAadharOtpScreen(false)
  //   setToggle(true);
  //   setOtp("")
  // }

  const handlePanChange = (e) => {
    let value = e.target.value.trim().toUpperCase(); // Add trim() here
    value = value.replace(/[^A-Z0-9]/g, "");
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    setPan(value);

    // PAN format: 5 letters, 4 digits, 1 letter (e.g., ABCDE1234F)
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (value.length === 10) {
      if (!panRegex.test(value)) {
        setError("Invalid PAN format");
      } else {
        setError("");
      }
    } else {
      // clear error if length not 10 yet
      setError("");
    }
  };


  return (
    <main>
    <Box
      sx={{
        display: "flex",
        flexDirection:isMobile ? "column" : "row",
        minHeight: "100vh",
        width: "100vw",
        overflowX: "hidden",
        backgroundImage: `url(${SignUpBg})`,
        backgroundSize: { xs: "cover", md: "cover" },
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontFamily: "Inter400",
          display: {
            xs: "block", // shown on small screens
          },
          mt: "5px",
          "@media (min-width:1000px)": {
            display: "none"
          }
        }}
      >
        {`You are on step ${activeStep + 1} out of 8`}
      </Typography>
      <StepperCard
        activeStep={activeStep}
        handleStepNavigate={handleStepNavigate}
        backendResponse={backendResponse}
        CustomStepConnector={CustomStepConnector}
        StepIcon={StepIcon}
        steps={steps}
      />
      <Box
        sx={{
          flex: 1,
          padding:"20px 0px 0px 0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          "@media (max-width:600px)": {
            justifyContent: "start"
          }
        }}
      >
        <img src={source == "cosmos" ? collab : Logo} alt="Logo" style={{ marginBottom: "10px" }} className={source == "cosmos" ? PanStyles.twologo : 
          PanStyles.logo} />
        {
          source == "cosmos" &&
          <Typography className={PanStyles.txt1}>
            Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
          </Typography>
        }

        {/* {showAadharOtpScreen ? (
          <Box className={AadharStyles.content_wrapper}>
            <Typography className={AadharStyles.heading}>
              Verify Aadhar OTP
            </Typography>
            <Typography sx={{ mb: 1, mt: 2 }} className={AadharStyles.txt}>
              Enter the OTP sent to your registered mobile number
            </Typography>

            <Box className={PanStyles.otp_container}>
              {[...Array(6)].map((_, index) => (
                <TextField
                  key={index}
                  id={`otp-${index}`}
                  value={otp[index] || ""}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  inputProps={{
                    maxLength: 1,
                    className: PanStyles.otp_input,
                    type: "tel",
                    inputMode: "numeric",
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      bgcolor: "white",
                      width: "84px",
                      height: "65px",
                      border: "1px solid #ccc",
                      fontSize: "32px",
                
                      "@media (max-width: 700px)": {
                        width: "60px",
                        height: "55px",
                        fontSize: "24px",
                      },
                      "@media (max-width: 500px)": {
                        width: "48px",
                        height: "48px",
                        fontSize: "20px",
                      },
                      "@media (max-width: 390px)": {
                        width: "44px",
                        height: "44px",
                        fontSize: "10px",
                      },
                      "@media (max-width: 365px)": {
                        width: "44px",
                        height: "44px",
                        fontSize: "6px !important",
                        padding:"0 !important"
                      },
                    },
                    "& input": {
                      textAlign: "center", // optional: centers the input
                    },
                  }}
                />
              ))}
            </Box>


            <Typography
              className={AadharStyles.linkbank}
              onClick={handleBack}
              sx={{ cursor: "pointer" }}
            >
              Edit Aadhar number
            </Typography>

            {error && (
              <Typography color="error" sx={{ marginTop: "10px" }}>
                {error}
              </Typography>
            )}

            <Button
              className={AadharStyles.button}
              disabled={otp.length !== 6}
              onClick={handleAadharOtpSubmit}
              sx={{ mt: 5 }}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </Button>
          </Box>
        ) : toggle ? (
          <Box className={AadharStyles.content_wrapper}>
            <Typography className={AadharStyles.heading}>
              Your Aadhar Details
            </Typography>
            <Grid2 className={AadharStyles.img_card}>
              <img
                src={aadharImg}
                alt="aadharimg"
                className={AadharStyles.pan_img}
              ></img>
            </Grid2>

            <TextField
              value={aadhar}
              onChange={handleAadharChange}
              variant="outlined"
              placeholder="Enter Aadhaar number"
              sx={{
                backgroundColor: "white",
                borderRadius: "39px",
                "& input": {
                  display: "flex",
                  alignItems: "center",
                  padding: "11px 12px",
                  textAlign: "center !important",
                  fontFamily: "Inter400 !important",
                  fontSize: "24px !important",
                  lineHeight: "29px !important",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderRadius: "39px",
                    height: "65px !important",
                    width: "399px !impoertant",
                    borderColor: "#000000",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#000000",
                    borderWidth: "1px",
                  },
                },
                width: "399px",
                height: "62px !important",
                "@media (max-width: 1000px)": {
                  width: "316px",
                  height: "46px !important",
                  "& input": {
                    fontSize: "18px !important",
                  },
                  "& .MuiOutlinedInput-root fieldset": {
                    height: "50px !important",
                    width: "299px !important",
                  },
                },
                "@media (max-width: 400px)": {
                  width: "288px",
                  height: "46px !important",
                  "& input": {
                    fontSize: "18px !important",
                  },
                  "& .MuiOutlinedInput-root fieldset": {
                    height: "50px !important",
                    width: "268px !important",
                  },
                },
              }}
            />
            {error && (
              <Typography color="error" sx={{ marginTop: "10px" }}>
                {error}
              </Typography>
            )}
            <Grid2 className={AadharStyles.but_card}>
              <Button
                className={AadharStyles.button}
                disabled={aadhar.length !== 12}
                onClick={handleAadharSubmit}
              >
                {loading ? "Sending OTP..." : "Send OTP"}
              </Button>
            </Grid2>

            <Box className={AadharStyles.card}>
           
              <Typography className={AadharStyles.txt}>
                Your account details are safe & secure with us.
              </Typography>
            </Box>
          </Box>
        ) : ( */}

          <Box className={PanStyles.content_wrapper}>
            <Typography className={PanStyles.heading}>
              Your PAN Details
            </Typography>
            <Grid2 className={PanStyles.img_card}>
              <img
                src={panImg}
                alt="panimg"
                className={PanStyles.pan_img}
              ></img>
            </Grid2>

            <TextField
              fullWidth
              value={pan}
            onChange={handlePanChange}
              variant="outlined"
              placeholder="Enter PAN number"
              sx={{
                backgroundColor: "white",
                borderRadius: "39px",
                "& input": {
                  display: "flex",
                  alignItems: "center",
                  padding: "11px 12px",
                  textAlign: "center !important",
                  fontFamily: "Inter400 !important",
                  fontSize: "24px !important",
                  lineHeight: "29px !important",
                  letterSpacing: "5px !important",
                  "&::placeholder": {
                    letterSpacing: "0px !important",
                  }
                  
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderRadius: "39px",
                    height: "65px !important",
                    width: "399px !impoertant",
                    borderColor: "#ABABAB",
                  },
                  "&:hover fieldset": {
                    borderColor: "#ABABAB !important", // stop hover change
                   
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#ABABAB",
                    borderWidth: "1px",
                  },
                },
                width: "399px",
                height: "62px !important",
                "@media (max-width: 1000px)": {
                  width: "316px",
                  height: "46px !important",
                  "& input": {
                    fontSize: "18px !important",
                  },
                  "& .MuiOutlinedInput-root fieldset": {
                    height: "50px !important",
                    width: "299px !important",
                  },
                },
                "@media (max-width: 400px)": {
                  width: "288px",
                  height: "46px !important",
                  "& input": {
                    fontSize: "18px !important",
                  },
                  "& .MuiOutlinedInput-root fieldset": {
                    height: "50px !important",
                    width: "268px !important",
                  },
                },
              }}
            />
            {error && (
              <Typography color="error" sx={{ marginTop: "10px" }}>
                {error}
              </Typography>
            )}

            <Grid2 className={PanStyles.but_card}>
              <Button
                className={PanStyles.button}
                onClick={handleVerifyPanAndContinue}
                disabled={!!error || pan.length !== 10 || loading}
              >
                {loading ? "Verifying..." : "Proceed"}
              </Button>
            </Grid2>

            <Box className={PanStyles.card}>
              <img src={icon} alt="Checkmark" className={PanStyles.icon} />
              <Typography className={PanStyles.txt}>
                Your account details are safe & secure with us.
              </Typography>
            </Box>
          </Box>
         {/* )} */}
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          "& .MuiSnackbar-root": {
            top: 34,
            right: 24,
          }
        }}
      >
        <Alert
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
    </main>
  );
}
